export function debounce (fn: CallableFunction, delayMilliseconds: number) {
  let timeout: NodeJS.Timeout
  return () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn()
    }, delayMilliseconds)
  }
}